export default {
  title: 'AI Agent 助手',
  cta: {
    tryFree: '免费试用',
    startNow: '立即开始',
    getStarted: '立即开始',
    learnMore: '了解更多',
    contactUs: '联系我们'
  },
  hero: {
    title: '智能',
    highlight: 'AI Agent',
    subtitle: '让您的工作更高效',
    description: '基于大语言模型的智能助手，为您提供全方位的工作支持，提升工作效率',
    cta: '立即开始',
    learnMore: '了解更多'
  },
  features: {
    title: '核心功能',
    description: '强大的功能助您轻松应对各种工作场景',
    cards: {
      agent: {
        title: 'AI Agent',
        description: '智能代理系统，可以根据您的需求自动完成各种任务',
        action: '查看详情',
        features: {
          customizable: '完全可定制',
          multilingual: '多语言支持',
          scalable: '可扩展架构'
        }
      },
      reasoning: {
        title: '智能推理',
        description: '强大的推理能力，帮助您分析复杂问题并提供解决方案',
        action: '了解更多',
        features: {
          contextual: '上下文理解',
          accurate: '精准推理',
          efficient: '高效处理'
        }
      },
      tools: {
        title: '工具集成',
        description: '丰富的工具集成，满足您的各种工作需求',
        action: '探索工具',
        features: {
          extensive: '丰富工具库',
          flexible: '灵活配置',
          secure: '安全可靠'
        }
      }
    }
  },
  showcase: {
    title: '应用展示',
    description: '看看其他用户是如何使用我们的产品的',
    more_cases: '更多案例',
    cases: {
      coding: {
        title: '代码开发',
        description: '智能编程助手，提供代码建议和自动补全',
        stats: '开发效率提升',
        performance: '开发效率提升75%',
        stats_title: {
          task: '任务类型',
          tools: '使用工具',
          performance: '性能表现',
          efficiency: '效率提升'
        },
        stats_value: {
          task: '代码开发',
          tools: 'VSCode/Git/CLI',
          performance: '代码质量优化',
          efficiency: '工时节省75%'
        }
      },
      analysis: {
        title: '数据分析',
        description: '智能数据分析，快速发现数据价值',
        stats: '数据分析效率',
        performance: '准确率提升到95%',
        action: '了解更多'
      },
      ask: {
        title: '智能问答',
        description: 'AI 驱动的问答服务，快速获取答案',
        action: '了解详情'
      },
      assistant: {
        title: '智能助手',
        description: '24小时在线的智能助手，为您解答各种问题',
        stats: '响应速度提升80%',
        performance: '响应速度提升80%',
        user_message: '你好，我需要帮助',
        ai_response: '您好！我是您的AI助手，很高兴为您服务',
        date: '2025-01-01',
        action: '查看对话',
        messages: {
          user1: '你好，我需要帮助',
          assistant1: '您好！我是您的AI助手，很高兴为您服务',
          user2: '能帮我分析一下这份数据吗？',
          assistant2: '当然可以，我来帮您详细分析一下'
        }
      },
      workflow: {
        title: '工作流',
        description: '智能工作流自动化，优化流程效率',
        date: '2025-01-01',
        action: '查看流程'
      },
      automation: {
        title: '自动化',
        description: '工作流程自动化，提高工作效率',
        stats: '自动化程度提升90%',
        performance: '自动化程度提升90%'
      }
    }
  },
  faq: {
    title: '常见问题',
    questions: {
      pricing: {
        question: '如何计费？',
        answer: '我们提供灵活的计费方案，包括按量计费和包月套餐，您可以根据实际需求选择合适的方案。'
      },
      howToStart: {
        question: '如何开始使用？',
        answer: '只需要简单的注册流程，您就可以立即开始使用我们的服务。我们还提供详细的使用文档和技术支持。'
      },
      platforms: {
        question: '支持哪些平台？',
        answer: '我们支持所有主流的操作系统和浏览器，包括但不限于Windows、MacOS、Linux等。'
      }
    }
  },
  footer: {
    title: 'Lagent - 智能AI Agent助手',
    description: '让您的工作更高效、更轻松',
    sections: {
      product: {
        title: '产品',
        features: '功能特性',
        pricing: '定价方案',
        cases: '使用案例',
        api: '开发接口'
      },
      resources: {
        title: '资源',
        docs: '开发文档',
        tutorials: '使用教程',
        blog: '博客文章',
        support: '技术支持'
      },
      company: {
        title: '公司',
        about: '关于我们',
        careers: '加入我们',
        contact: '联系我们',
        partners: '合作伙伴'
      },
      legal: {
        title: '法律',
        privacy: '隐私政策',
        terms: '使用条款',
        cookies: 'Cookie政策',
        security: '安全说明'
      }
    },
    keywords: {
      neural: '神经网络',
      machine: '机器学习',
      deep: '深度学习',
      vision: '计算机视觉',
      nlp: '自然语言处理',
      mining: '数据挖掘',
      tiktok: '抖音',
      facebook: 'Facebook',
      analysis: '数据分析',
      market: '市场营销',
      content: '内容创作',
      creative: '创意设计',
      roi: '投资回报',
      insights: '数据洞察',
      trend: '趋势分析',
      metrics: '性能指标',
      campaign: '营销活动'
    },
    copyright: '版权所有 2025 Lagent.'
  }
}
